import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputBase,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { countries } from "../../utils/CountryCodes";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { verifyDomain } from "../../api/StoreApis";
import { toast } from "react-toastify";
import { createStore } from "../../api/StoreApis";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const categoryList = {
  Fashion: ["Dresses", "Shoes", "Accessories", "Other"],
  Beauty: ["Skincare", "Makeup", "Fragrances", "Other"],
  Electronics: ["Smartphones", "Laptops", "Headphones", "Other"],
  "Home Goods": ["Furniture", "Kitchen Appliances", "Decor", "Other"],
  Toys: ["Action Figures", "Board Games", "Dolls", "Other"],
  "Health and Wellness": [
    "Vitamins",
    "Fitness Equipment",
    "Supplements",
    "Other",
  ],
  "Pet Supplies": ["Dog Food", "Cat Toys", "Fish Tanks", "Other"],
  "Outdoor Gear": ["Camping Gear", "Hiking Boots", "Bicycles", "Other"],
  Books: ["Fiction", "Non-Fiction", "Mystery", "Other"],
  Others: ["Miscellaneous", "Random", "Unspecified", "Other"],
  "Groceries & Pets": ["Fresh Produce", "Fresh Fruit", "Fresh Vegetables", "Fish & Cold Pressed Juices", "Bread", "Eggs", "Dry Fruits", "Breakfast, Choco's & Snacks", "Breakfast Cereals", "Jams, Honey & Spreads", "Breakfast Bars", "Instant Breakfast Drinks", "Chocolate & Candy", "Chewing Gums & Mints", "Biscuit & Cookies", "Cakes & Sweets", "Chips & Crisps", "Nuts & Legumes", "Oatmeal", "Pancake & Waffle Mixes", "Beverages", "Tea", "Coffee", "UHT, Milk & Milk Powder", "Soft Drinks", "Juices", "Water", "Flavouring Syrup", "Powdered Drinks", "Food Staples", "Oil", " Rice", "Condiment Dressing", "Cooking Ingredients", "Noodles & Pasta", "Instant & Ready-to-Eat", "Grains, Beans & Pulses", "Home Baking & Sugar", "Jarred Food", "Canned Food", "Laundry & Household", "AirCare", "Cleaning", "Dishwashing", "Laundry", "Pest Control", "Tissue Paper", "Foils & Cling Films", " Frozen Food", "Chicken", "Beef", "Other Frozen Food", "Cat Food", "Cat Beds, Mats & Houses", "Cat Carriers & Travel", "Cat Grooming", "Cat Litter & Toilet", "Cat Cages, Crates & Doors", "Cat Toys", "Cat Treats", "Cat Trees, Condos & Scratchers", "Cat Bowls & Feeders", "Dog Collars", "Dog Toys", "Dog Harnesses", "Dog Brushes & Combs", "Dog Shampoos & Bath Accessories ", "Dog Bowls & Diners", "Dog Beds", "Fish", "Decorations", "Water pumps", "Aquariums", "Filters & Accessories", "Air Pumps & Accessories", "Temperature control supplies", "Food"],
  "Health & Beauty": ["Makeup", "Makeup Accessories", "Lips", "Nails", "Face", "Eyes", "Makeup Removers", "Makeup Palettes & Sets", "Bulk Deals", "Beauty Tools", "Skin Care Tools", "Hair Removal Appliances", "Slimming & Electric Massagers", "Hair Styling Appliances", "Foot Relief Tools", "Skin Care", "Moisturizers and Cream", "Facial Cleansers", "Serum & Essence", "Face Mask & Packs", "Sunscreen & Aftersun", "Lip Balm & Treatment", "Eye Care", "Face Scrubs & Exfoliators", "Toner & Mists", "Hair Care", "Shampoo & Conditioner", "Hair Care Accessories", "Hair Treatments", "Oil & Serums", "Hair Coloring", " Hair Styling", "Body Soaps & Shower Gels", "Hair Removal", "Body & Massage Oils", "Bath & Body Accessories", "Foot Care", "Hand Care", "Bath & Body", "Hair Care", "Shaving & Grooming", "Personal Care", "Pads & Tampons", "Menstrual Cups", "Oral Care", "Eye Care", "Deodorants", "Adult Diapers", "Personal Safety & Security", " Ear Care", "Fragrances for Women", "Fragrances for Men", "Fragrances for Unisex", "Sexual Wellness", "Condoms", "Lubricants", "Medical Supplies", "Health Monitors & Tests", "Health Accessories", "First Aid Supplies", "Ointments and Creams", "Surgical Masks", "Nebulizer & Aspirators", "Stethoscopes"],

  "Men's Fashion": ["T Shirts & Tanks", "V Neck", "Round Neck", "Graphic tees", "Top Rated", "Shirts & Polo", "Casual Shirts", "Formal Shirts", "Polos", "Pants & Jeans", "Chinos", "Cargo", "Jeans", "Shorts, Joggers & Sweats", "Shorts", "Joggers & Sweats", "Unstitched Fabric", "Kurtas & Shalwar Kameez", "Kurtas", "Shalwar", "Shawls", "Winter Clothing", "Jackets & Coats", "Hoodies & Sweatshirts", "Sweaters & Cardigans", "Inner Wear", "Briefs", "Trunk & Boxers", "Nightwear", "Vests", "Thermal", "Socks", "Shoes", "Slip-Ons & Loafers", "Flip Flops & Sandals", "Sneakers", "Formal Shoes", "Boots", "Khusa & Kolapuri", "Shoes Accessories", "Accessories", "Belts", "Sunglasses", "Hats & Caps", "Boy's Clothing", "T-Shirts & Shirts", "Pants & Jeans", "Shorts", "Kurtas & Shalwar Kameez", "Underwear & Socks", "Ties & Bows", "Shoes", "Sneakers", "Slip-Ons & Loafers", "School Shoes", "Flip Flops, Slides & Sandals", "Formal Shoes", "Boots ", "Sandals", "Boy's Accessories", "Belts", "Inner Wear", "Socks", "Hats & Caps"],

  "Women's Fashion": ["Unstitched Fabric", "Branded Unstitched", "Sarees", "Kurtas & Shalwar Kameez", "Kurtis", " Shalwar Kameez", "Branded Pret", "Trousers & Palazzos", "Muslim Wear", "Dupattas, Stoles & Shawls", "Abayas & Hijabs", "Scarves", " Hair Accessories", "Tops", "Blouses & Shirts", "Tunics", " T-Shirts", "Bras", "Panties", "Lingerie Sets", "Beachwear and Bikinis", "Socks & Tights", "Sleepwear & Innerwear", "Nightwear", "Robe and Gown sets", "Tanks & Camisoles", "Shapewear", "Pants", "Leggings", "Jeans", "Shorts", "Jeggings", "Dresses & Skirts", "Ethnic Dresses", "Western Dresses", "Skirts", " Formal Wear", "Winter Clothing", "Jackets & Coats", "Hoodies & Sweatshirts", "Sweaters & Cardigans", "Shawls and Poncho's", "Shrugs", "Shoes", "Sandals", "Flat Shoes", "Heels", "Khussa & Kohlapuri", "Slides & Flip FLops", " Wedges", "Sneakers", "Boots", "Shoes Accessories", "Girls Clothing", "Dresses", "Tops", "Underwear & Sleepwear", "Bottoms", "Socks & Tights", "Jackets & Coats", "Swimsuits", "Hoodies", "Hair Accessories", "Hats & Caps", "Belts", "Gloves, Scarves & Cold Weather", "Girls Shoes", "Sneakers", "Flats & Slip - Ons", "Formal Shoes", "Sandals", "Flip Flops, Slides & Sandals", "School Shoes", "Boots"],

"Mother & Baby": ["Milk Formula & Baby Food", " Maternal", "Infant Milk (0-6 Months)", "Infant Milk (6-12 Months)", " Toddler Milk (1 - under 3 yrs)", "Growing-up Milk (3 yrs +)", "Baby & Toddler Foods", "Diapering & Potty", "Disposable diapers", "Diaper Bags", "Wipes & Holders", "Changing Tables, Pads & Kits", "Diapering Care", "Cloth Diapers & Accessories", "Potty Training", "Feeding", "Utensils", "Bottle-Feeding", "Breastfeeding", "Food Blenders", "Pacifiers & Teethers", "Baby & Toddler Foods", "Maternity Care", "Maternity Wear", "Maternity Accessories", "Nursing Covers", "Pregnancy Pillows", "Nipple Care", "Breast Shells", "Breast Pumps", "Baby Gear", "Kids Bag", "Swings, Jumpers & Bouncers", "Strollers", "Car Seats", "Walkers", "Backpacks & Carriers", "Harnesses & Leashes", "Baby Safety", "Baby Monitor", "Highchairs & Booster Seats", "Baby Sofas", "Nursery ", "Baby Furniture", "Mattresses & Bedding", "Storage & Organization", "Nursery Decor", "Baby Personal Care", "Skin Care", "Bathing Tubs & Seats", "Soaps, Cleansers & Bodywash", "Baby Groomings & Care Kits", "Grooming & Healthcare Kits", "Toothbrushes & Toothpaste", "Shampoo & Conditioners", "Washcloths & Towels", "Baby Bath Mats", "Clothing & Accessories", "Newborn", "New Born Unisex (0 - 6 mnths)", "New born bodysuits", "New born sets & Packs", "Accessories", "Boys (Under 3 Years)", "Girls (Under 3 Years)", "Baby & Toddler Toys", "Activity Gym & Playmats", "Bath Toys", "Building Blocks Toys", "Crib Toys & Attachments", "Early Development Toys", "Music & Sound", "Rattles", "Push & Pull Toys", "Remote Control & Vehicles", "Die-Cast Vehicles", "Drones & Accessories", "Play Trains & Railway Sets", "Play Vehicles", "RC Vehicles & Batteries", "Sports & Outdoor Play", "Inflatable Bouncers", "Swimming Pool & Water Toys", "Fidget Spinners", "Toys & Games", "Arts & Crafts for Kids", "Action Figures & Collectibles", "Blocks & Building toys", "Dolls & Accessories", "Learning & Education", "Puzzle & Boardgames", "Slime & Squishy Toys", "Stuffed Toys", "Pretend Play"],

    " Home & Lifestyle": ["Bath Mats", "Bath Towels", "Bathrobes", "Bathroom Scales", "Bathroom Shelving", "Shower Caddies & Hangers", "Shower Curtains", "Towel Rails & Warmers", "Bed Sheets", "Bedding Accessories", "Blankets & Throws", "Comforters, Quilts & Duvets", "Mattress Protectors", "Pillow Cases", "Pillows & Bolsters", "Artificial Flowers & Plants", "Candles & Candleholders", "Clocks", "Curtains", "Cushions & Covers", "Mirrors", "Picture Frames", "Rugs & Carpets", "Vases & Vessels", "Wall Stickers & Decals", "Bedroom", "Gaming Furniture", "Home Office", "Kitchen Furniture", "Living Room", "Bakeware", "Coffee & Tea", "Cookware", "Dinnerware", "Drinkware", "Kitchen & Table Linen", "Kitchen Storage & Accessories", "Kitchen Utensils", "Knives & Accessories", "Serve ware", "Ceiling Lights", "Floor Lamps", "Lamp Shades", "Light Bulbs", "Lighting Fixtures & Components", "Outdoor Lighting", "Rechargeables & Flashlights", "Table Lamps", "Laundry & Cleaning", "Brushes, Sponges & Wipers", "Brooms, Mops & Sweepers", "Laundry Baskets & Hampers", "Clothes Line & Drying Racks", "Ironing Boards", "Fixtures & Plumbing", " Electrical", "Hand Tools", "Lawn & Garden", "Power Tools", "Security", "Home Build Up", "Primers", "Paints", "Art Supplies", "Gifts & Wrapping", "Packaging & Cartons", "Paper Products", "School & Office Equipment", "Writing & Correction", "School Uniforms", "Books", " English Books", "Islamic Books", "English Literature Books", " English Story Books", "History Books", "eBooks", "Magazines", "Musical Instruments"],

    "Electronic Devices": ["Apple iPhones", "Xiaomi Mi Mobiles", "Nokia Mobiles", "Redmi Mobiles", "Realme Mobiles", "Oppo Mobile Phones", "Oneplus Mobiles", "Infinix Mobiles", "Honor Mobiles", "Tecno Mobiles", "Samsung Mobile Phones", "Vivo Mobiles", "Feature Phones", "Tablets", "Monitors", "Laptops", "Refurbished Laptops", "Traditional Laptops", "Like New Laptops", "Desktops", "Smart Watches", "PlayStation Consoles", " Playstation Games", "Playstation Controllers", "Nintendo Games", "Xbox Games", "Video Camera", "DSLR", "Drones", "Point & Shoot", "Instant Cameras", "Security Cameras", "Landline Phones"],

    "Electronic Accessories": ["Phone Cases", "Power Banks", "Cables & Converters", " Wall Chargers", "Wireless Chargers", "Tablet Accessories", "Car Chargers", "Screen Protectors", "Phone Camera Flash Lights", "Selfie Sticks", "Docks & Stands", "Car Mounts", "Headphones & Headsets", "Bluetooth Headsets", "Headphones & Headsets Access.", "Mono Headsets", "Over-The-Ear Headphones", "Wired Headsets", "Wireless Earbuds", "In-Ear Headphones", "Wearable", "Smartwatches", "Fitness & Activity Trackers", "Fitness Tracker Accessories", "Virtual Reality", "Camera Accessories", "Memory Cards", "Lenses", "Tripods & Monopods", "Camera Cases, Covers and Bags", "Action Camera Accessories", "Gimbals & Stabilizers", "Lighting & Studio Equipment", "Batteries", "Computer Accessories", "Cooling Pads/Cooling Stands", "Mouse", "Adapters & Cables", "PC Audio", "Mac Accessories", "Keyboards", "Storage", "External Hard Drives", "Internal Hard Drives", "Flash Drives", "Storage for Mac", "OTG Drives", "Printers", " Printers", "Ink & Toners", "Fax Machines", "Computer Components", "Graphic Cards", "Desktop Casings", "Motherboards", "Fans & Heatsinks", "Processors", "Portable Speakers", "Network Components", " Access Points", "Gaming Accessories", "Gaming Mouse", "Gaming Keyboards", "Gaming Headsets", "Monitors & Accessories"],

    "TV & Home Appliances": ["Air Conditioner", "Televisions", "Smart Televisions", "LED Televisions", "Refrigerators & Freezers", "Refrigerators", " Freezers", "Home Audio & Theater", "Home Entertainment", "Live Sound & Stage Equipment", "Home Theater Systems", "Soundbar Speakers", "Washing Machine", "Kitchen Appliances", "Microwave", "Oven", "Air & Deep Fryers", "Blender, Mixer & Grinder", "Juicer & Fruit Extraction", "Water Dispensers", "Electric Kettle", "Dishwashers", "Cooktop & Range", "Rice Cooker", "Pressure Cookers", "Specialty Cookware", "Cooling & Heating", " Air Cooler", " Fan", " Air Purifier", " Dehumidifier", " Humidifier", "Water Heater", " Room Heater", "Irons & Garment Care", " Irons", " Garment Steamer", "Sewing Machine", "Generator, UPS & Solar", "Generators", "UPS", "Solar Inverters", "Projectors & Players", "Blu Ray & DVD Players", "Projectors", "TV Accessories", "TV Receivers", "Wall Mounts & Protectors", "TV Adapters", "TV Remote Controllers", "3D Glasses", "Antennas", "Cables", "Vacuums & Floor Care", "Vacuum Cleaner", "Floor Polisher", "Steam Mops", "Electric Brooms"],

    "Sports & Outdoor": ["Exercise & Fitness", "Cardio Training Equipment", "Strength Training Equipments", "Treadmills", "Fitness Accessories", "Boxing, Martial Arts & MMA", "Weight", "Yoga", "Exercise Bands", "Exercise Bikes", "Supplements", "Proteins", "Post Workouts and Recovery", "Pre Workouts", "Fat Burners", "Post Workouts and recovery", "Shoes & Clothing", "Mens Shoes", "Mens Clothing", "Womens Shoes", "Womens Clothing", "Men Accessories", "Men Bags", "Women Accessories", "Women Bags", "Team Sports", "Cricket", "Football", "Hockey", "Basket Ball", "Volley balls", "Baseballs", "Racket Sports", "Rackets", "Shuttlecocks", "Balls", "Bats", "Nets", "Grips & Tapes", "Balls", "Outdoor Recreation", "Cycling", "Cycle accessories", "Camping / Hiking", "Other activities", "Water Sports", "Fishing", "Skate Boards", "Fitness Gadgets", "Fitness Trackers", "Fitness Trackers Accessories", "Sports Accessories", "Water Bottles", "Home Gym"],

    "Watches, Bags & Jewellery" : ["Men's Watches", "Chronograph-Men's Watches", "Branded-Men's Watches", "Analog-Men's Watches", "Digital-Men's Watches", "Accessories-Men's Watches", "Smart Watches-Men's Watches", "Women's Watches", "Chronograph-Women's Watches", "Branded-Women's Watches", "Analog-Women's Watches", "Digital-Women's Watches", "Accessories-Women's Watches", "Smart Watches-Women's Watches", "Kid's Watches", "Boys", "Girls", "Womens Bags", "Cross Body & Shoulder Bags", "Top-Handle Bags", "Tote Bags", "Backpacks", "Clutches", "Wallets & Accessories", "Wristlets", "Mens Bags", "Wallets & Cardholders", "Backpacks", "Crossbody Bags", "Business Bags", "Messenger Bags", "Cardholders & Keychains", "Luggage & Suitcase", "Travel Accessories", "Laptop Bags", "Luggage", "Duffel Bags", "Womens Jewellery", "Rings", "Earrings", "Necklaces", "Bracelets", "Anklets", "Jewellery Sets", "Mens Jewellery", "Rings", "Chains", "Bracelets", "Studs", "Pendants", "Mens Accessories", "Belts", "Hats & Caps", "Scarves", "Socks", "Ties & Bow Ties", "Gloves", "Women's Accessories", "Scarves", "Belts", "Socks & Tights", "Hats & Caps", "Gloves", "Hair Accessories", "Sunglasses & Eyewear", "Sunglasses", "Unisex Sunglasses", "Women Eyeglasses", "Unisex Eyeglasses", "Kids Sunglasses", "Women Sunglasses", "Men Eyeglasses", "Kids Eyeglasses", "Lenses"],

    "Automotive & Motorbikes": ["Automotive", "Car Tires & Wheels", "Car Oils & Fluids", "Car Interior Accessories", "Car Tools & Equipment", "Car Parts & Spares", "Car Care", "Car Exterior Accessories", "Car Electronics", "Car Safety & Security", "Motorcycle", "Electric Bikes", "Standard Bikes", "ATVs & UTVs", "Sports Bikes", "Riding Gear", "Motorcycle Helmets", "Motorcycle Tires & Wheels", "Motorcycle Parts & Spares", "Motorcycle Oil & Fluids", "Motorcycle Accessories", "Loaders & Rickshaw", "Loaders", "Auto Rikshaw"],
};

const categoryNames=Object.keys(categoryList);

const Register = () => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    businessName: "",
    shopUrl: "",
    loading: false,
    categories: [],
    phoneNumber: "",
    onWhatsapp: true,
    countryCode: JSON.stringify(countries[0]),
    domainError: null,
  });

  const handleCodeChange = (event) => {
    setState({ ...state, countryCode: event.target.value });
  };

  const handleCategoryChange = (event) => {
    const {
      target: { value },
    } = event;
    // setPersonName(typeof value === "string" ? value.split(",") : value);
    setState({
      ...state,
      categories: typeof value === "string" ? value.split(",") : value,
    });
  };

  function transformString(inputString) {
    return inputString.replace(/\s+/g, "").toLowerCase();
  }

  function extractDomain(url) {
    // Remove "www." if it exists at the beginning of the URL
    url = url.replace(/^(www\.)+/i, "");

    // Split the URL by dots
    const parts = url.split(".");

    // If the URL has two parts, it's likely a main domain
    if (parts.length === 2) {
      return parts.join(".");
    }

    // If the URL has more than two parts, consider it as subdomain/main domain
    if (parts.length > 2) {
      return `${parts[0]}.${parts.slice(1).join(".")}`;
    }

    // If the URL doesn't match the above patterns, return the original URL
    return url;
  }
// to check the validity of business name 
function isValidBusinessName(businessName) {
  // Allow spaces and alphanumeric characters, but not solely numeric values
  const pattern = /^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/;
  return pattern.test(businessName);
}

  const handleVerifyDomain = async () => {
    // validate the business name
    if(!isValidBusinessName(state.businessName))
    {
      setState({
        ...state,
        domainError: 'Invalid characters in business name. Please use only alphabetical characters.'
      });
    }else{
      const response = await verifyDomain(state.businessName);
      if (response?.status === 200) {
        const currentDomain = window.location.hostname;
        const extractedDomain = extractDomain(currentDomain);
  
        setState({
          ...state,
          shopUrl: `${transformString(state.businessName)}.${extractedDomain}`,
        });
      } else {
        setState({
          ...state,
          domainError: "Shop with this name already exists",
        });
      }
    }

  };

  const handleSubmit = async () => {
    if (
      state.businessName === "" ||
      state.phoneNumber === "" ||
      state.shopUrl === "" ||
      state.categories.length === 0
    ) {
      toast.error("Error: Fill in required fields. ");
      return;
    }

    if (state.domainError) {
      toast.error("Error: Business name already exists.");
      return;
    }

    let storeObj = {
      store_name: state.businessName,
      shop_url: state.shopUrl,
      phone_number:
        JSON.parse(state.countryCode)?.dial_code + "-" + state.phoneNumber,
      shop_category: state.categories,
      onWhatsapp: state.onWhatsapp,
    };

    let resp = await createStore(storeObj);

    if (resp?.status === 200) {
      toast.success(" Success: Store created.");
      navigate("/dashboard/index");
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 3,
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "25px",
            lineHeight: "0.6",
            mb: "10px",
          }}
        >
          CREATE SHOP
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#8E8E8E" }}>
          Build Your Dream Shop on Uchlo!
        </Typography>
      </Box>

      <TextField
        size="small"
        label="Business Name"
        value={state.businessName}
        onChange={(e) => {
          setState({
            ...state,
            businessName: e.target.value,
            domainError: null,
          });
        }}
        onBlur={handleVerifyDomain}
        error={state.domainError}
        helperText={state.domainError}
      />

      <TextField
        size="small"
        label="Shop URL"
        value={state.shopUrl}
        disabled
        sx={{
          color: "black",
          ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled":
            {
              WebkitTextFillColor: "rgba(0, 0, 0, 1)",
              color: "black",
            },
        }}
        // onChange={(e) => setState({ ...state, shopUrl: e.target.value })}
      />

      <FormControl
        sx={{
          background: "#fff",
          borderRadius: "20px",
          width: "100%",
          py: "6px",
        }}
        size="small"
        variant="standard"
      >
        <InputLabel
          id="demo-multiple-chip-label"
          variant="standard"
          sx={{ top: "-3px", left: "14px" }}
        >
          Select Category
        </InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          disableunderline="true"
          multiple
          // onFocus={handleFocus}
          // onBlur={handleBlur}
          value={state.categories}
          onChange={handleCategoryChange}
          input={<OutlinedInput label="Select Category" />}
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
              }}
            >
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {categoryNames.map((name) => (
            <MenuItem
              key={name}
              value={name}
              // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: "5px",
          background: "#fff",
          border: "1px solid gray",
          height: "40px",
          overflow: "hidden",
        }}
      >
        <Select
          labelId="phone-code-select-label"
          id="phone-code-select"
          value={state.countryCode}
          onChange={handleCodeChange}
          disableUnderline
          label="Phone Code"
          sx={{
            width: "110px",
            pl: "10px",
            pt: "5px",
          }}
          variant="standard"
          size="small"
        >
          {countries.map((c) => (
            <MenuItem
              key={c.code}
              value={JSON.stringify(c)}
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span className={`fi fi-${c.code.toLocaleLowerCase()}`}></span>{" "}
              {c.dial_code}
            </MenuItem>
          ))}
        </Select>
        <TextField
          size="small"
          label="Contact No."
          type={"number"}
          placeholder="3456789100"
          sx={{
            width: "100%",
          }}
          InputProps={{ disableUnderline: true }}
          variant="filled"
          defaultValue={state.phoneNumber}
          onChange={(e) =>
            setState({
              ...state,
              phoneNumber: e.target.value,
            })
          }
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          component="p"
          sx={{
            fontSize: "12px",
            width: "100%",
            px: "10px",
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          Is this number available on&nbsp;
          <Typography
            component="p"
            sx={{
              fontSize: "12px",
              color: "#25D366",
              fontWeight: "bold",
            }}
          >
            WhatsApp?
          </Typography>
        </Typography>

        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          sx={{ mx: "auto" }}
        >
          <FormControlLabel
            value="yes"
            control={
              <Radio
                size="small"
                icon={<RadioButtonUncheckedIcon sx={{ fontSize: "14px" }} />}
                checkedIcon={
                  <RadioButtonCheckedIcon sx={{ fontSize: "14px" }} />
                }
                sx={{
                  // color: "#fff",
                  "&.Mui-checked": {
                    color: "#FC6B00",
                  },
                  p: "5px",
                }}
                checked={state?.onWhatsapp}
                onChange={(e) =>
                  setState({
                    ...state,
                    onWhatsapp: true,
                  })
                }
              />
            }
            label={<Typography sx={{ fontSize: "12px" }}>Yes</Typography>}
          />
          <FormControlLabel
            value="no"
            control={
              <Radio
                size="small"
                icon={<RadioButtonUncheckedIcon sx={{ fontSize: "14px" }} />}
                checkedIcon={
                  <RadioButtonCheckedIcon sx={{ fontSize: "14px" }} />
                }
                checked={!state?.onWhatsapp}
                sx={{
                  // color: "#fff",
                  "&.Mui-checked": {
                    color: "#FC6B00",
                  },
                  p: "5px",
                }}
                onChange={(e) =>
                  setState({
                    ...state,
                    onWhatsapp: false,
                  })
                }
              />
            }
            label={<Typography sx={{ fontSize: "12px" }}>No</Typography>}
          />
        </RadioGroup>
      </Box>

      <Button
        variant="contained"
        color="secondary"
        sx={{ borderRadius: "20px" }}
        onClick={handleSubmit}
        disabled={state.loading}
      >
        {state.loading ? (
          <CircularProgress size={"25px"} sx={{ color: "#fff" }} />
        ) : (
          "Create Shop"
        )}
      </Button>
    </Box>
  );
};

export default Register;
